import {
    combineTwoProjects,
    combineTasks,
    sortProjectTasks,
} from "../../redux/reducers/TodoManipulation/projectReducer";
import { orderSiblingsInTodo } from "../../redux/actions/TodoManipulation/orderSiblingsAction";
import { changeSiblingPosition } from "../../redux/actions/TodoManipulation/changeSiblingPositionAction";
import { changeParentOfTask } from "../../redux/actions/TodoManipulation/changeParentAction";
import { findByIdInTreeList, getChildrenById, getChildrenByRefId, getParentId, checkForSubProjects, prioritizeUnprioritizedTasks, findBy$IdInTreeList } from "../../utils/tree";
import { changePriorityOfTask } from "../../redux/actions/TodoManipulation/changePriorityAction";
import { changeGlobalPrioritySynchronously, changeSiblingPositionSynchronously, changeParentSynchronously, changeTodoPrioritySynchronously, orderSiblingsSynchronously } from "../../redux/actions/synchronousAction";
import { useSelector } from "react-redux";
import { changeTypeOfTodo } from "../../redux/actions/TodoManipulation/changeTypeAction";
import { setDragOperationInProgress, clearDragOperation } from "./dragOperationState";

export const onDragStartFunction = (start, setIsProjectDragging, setCurrentlyDraggedProjectId) => {
    setIsProjectDragging(false);
    setCurrentlyDraggedProjectId(start.draggableId);
};

export const onDragEndFunction = async (id, projects, filteredProjects, result, dispatch, showCompleted = null, isProjectDragging = null, setIsProjectDragging = () => { }, newPriorityTodo = null, priorityList = null, priorityUpdates = []) => {

    const { source, destination, type, combine, draggableId } = result;
    
    // Set flag to prevent SignalR from causing UI flicker during the operation
    setDragOperationInProgress();
    
    try {
        if (type === "project") {
            let draggedProject, droppedProject;
            const sortedProjects = structuredClone(projects).sort((a, b) => a.siblingOrder - b.siblingOrder);
            if (!destination && !combine) {
                return;
            }
            if (type === "project" && combine != null) {
                draggedProject = findBy$IdInTreeList(projects, draggableId);
                droppedProject = findBy$IdInTreeList(projects, combine.draggableId);
                const changeParentJson = {
                    id: draggedProject.id,
                    ParentId: droppedProject.id,
                    SiblingPosition: (droppedProject.children && droppedProject.children.length > 0) ? droppedProject.children.length - 1 : 0,
                    getTask: true
                }
                await dispatch(changeParentOfTask(changeParentJson));
            }
            else if (type === "project" && destination.droppableId === "all-projects") {
                if (filteredProjects.projects.length === projects.length) {
                    
                    const json = {
                        id: id,
                        newPosition: result.destination.index,
                    };

                    dispatch(changeSiblingPositionSynchronously(id, destination.index));
                    await dispatch(changeSiblingPosition(json));
                } else {
                    
                    const filteredIndex = destination.index; 
                    const droppedProjectInFiltered = filteredProjects.projects[filteredIndex];

                    
                    const droppedProjectIndexInProjects = droppedProjectInFiltered
                        ? sortedProjects.findIndex(project => project.id === droppedProjectInFiltered.id)
                        : 0; 

                    const json = {
                        id: id,
                        newPosition: droppedProjectIndexInProjects,
                    };

                    
                    dispatch(changeSiblingPositionSynchronously(id, filteredIndex)); 
                    await dispatch(changeSiblingPosition(json)); 
                }
            }
        }
        if (type === "task") {
            if (!source && !destination) {
                return;
            } else if (combine != null) {
                dispatch(
                    combineTasks({
                        sourceTaskId: draggableId,
                        sourceRootProjectId: source.droppableId,
                        destinationRootProjectId: combine.droppableId,
                        destinationSubprojectId: combine.draggableId,
                    })
                );
            } else if (!destination) {
                // Task has been dropped into no project
                //dispatch(
                //    makeSubprojectRootProject({
                //        oldProjectId: source.droppableId,
                //        movedTaskId: draggableId,
                //    })
                //);
            }   // Change task/sub project order
            else if (source.droppableId === destination.droppableId) {

                if (source.index === destination.index || source.droppableId === "unsorted") return;

                // Check if we're on To-Do page (has priorityList) or Overview page (no priorityList)
                const isTodoPage = priorityList !== null && priorityList !== undefined;

                if (isTodoPage) {
                    // TO-DO PAGE: Use global priority
                    let children = getChildrenByRefId(projects, source.droppableId)
                        .filter((child) => !showCompleted ? !child.isCompleted : true)
                        .sort((a, b) => a.globalPriority - b.globalPriority);

                    const movedTask = children.splice(source.index, 1)[0];
                    children.splice(destination.index, 0, movedTask);

                    dispatch(changeGlobalPrioritySynchronously(children));

                    const priorityUpdates = prioritizeUnprioritizedTasks(projects, source.droppableId);

                    const lastIndex = children.length - 1;
                    let newPriority = 0;

                    if (destination.index === 0) {
                        // Moving to first position - set priority lower than first task
                        const firstTask = children[0];
                        if (firstTask.globalPriority && firstTask.globalPriority > 1) {
                            newPriority = firstTask.globalPriority - 1;
                        } else {
                            newPriority = 0.5;
                        }
                    } else if (destination.index === lastIndex) {
                        // Moving to last position - set priority higher than last task
                        const lastTask = children[lastIndex];
                        if (lastTask.globalPriority && lastTask.globalPriority > 0) {
                            newPriority = lastTask.globalPriority + 1;
                        } else {
                            newPriority = children.length;
                        }
                    } else {
                        // Moving between tasks - calculate midpoint priority between neighbors
                        const prevTask = children[destination.index - 1];
                        const nextTask = children[destination.index + 1];
                        
                        const prevPriority = (prevTask && prevTask.globalPriority) ? prevTask.globalPriority : 0;
                        const nextPriority = (nextTask && nextTask.globalPriority) ? nextTask.globalPriority : prevPriority + 2;
                        
                        // Calculate midpoint between the two surrounding tasks
                        newPriority = (prevPriority + nextPriority) / 2;
                    }

                    const json = {
                        id: id,
                        priority: newPriority,
                        priorityUpdates: priorityUpdates
                    }

                    await dispatch(changePriorityOfTask(json));
                } else {
                    // OVERVIEW PAGE: Use sibling order
                    const parent = findBy$IdInTreeList(projects, source.droppableId);
                    
                    let children = parent ? parent.children : projects;
                    
                    // Sort by siblingOrder for Overview page
                    const sortedChildren = [...children]
                        .filter((child) => !showCompleted ? !child.isCompleted : true)
                        .sort((a, b) => a.siblingOrder - b.siblingOrder);

                    // Get ordered IDs array after moving the task
                    const orderedIds = sortedChildren.map(child => child.id);
                    const draggedId = id;
                    
                    // Remove the dragged item from its current position
                    const draggedIndex = orderedIds.indexOf(draggedId);
                    if (draggedIndex > -1) {
                        orderedIds.splice(draggedIndex, 1);
                    }
                    
                    // Insert at the new position
                    orderedIds.splice(destination.index, 0, draggedId);

                    // Call the orderSiblings endpoint - use parent's actual GUID id, not $id
                    const json = {
                        id: parent ? parent.id : null,  // Parent's GUID ID (null for root level)
                        Ids: orderedIds
                    };

                    // Optimistic update - immediately update local state before API call
                    dispatch(orderSiblingsSynchronously(parent ? parent.id : null, orderedIds));
                    
                    await dispatch(orderSiblingsInTodo(json));
                }

            }
            // Change Parent
            else if (source.droppableId !== destination.droppableId || source.droppableId === "unsorted") {

                const parentID = getParentId(projects, destination.droppableId);

                const changeParentJson = {
                    id: id,
                    ParentId: parentID,
                    SiblingPosition: destination.index,
                    getTask: true
                }

                dispatch(changeParentSynchronously(id, destination.droppableId, source.droppableId, destination.index));

                await dispatch(changeParentOfTask(changeParentJson));

                const hasChildren = getChildrenById(projects, id)

                if (source.droppableId === "unsorted" && hasChildren.length > 0) {
                    await dispatch(changeTypeOfTodo({ id: id, type: 1 }));
                }
            }
        }
        else if (type === "todo") {
            // Update only the moved task's priority synchronously (preserves fractional priority system)
            dispatch(changeTodoPrioritySynchronously(id, newPriorityTodo));
            
            // priorityUpdates contains any legacy tasks that had null globalPriority and were assigned values
            const json = {
                id: id,
                priority: newPriorityTodo,
                priorityUpdates: priorityUpdates.map(p => ({ Id: p.id, Priority: p.priority }))
            }
            
            await dispatch(changePriorityOfTask(json));
        }
        if (isProjectDragging !== null) {
            setIsProjectDragging(false);
        }
    } finally {
        // Always clear the flag when operation completes (success or error)
        clearDragOperation();
    }
};

export const onEditModalDragEndFunction = async (todo, projects, result, dispatch, showCompleted, isProjectDragging = null, setIsProjectDragging = () => { }) => {

    const { source, destination } = result;

    if (source.droppableId === destination.droppableId) {
        //Change sibling order of tasks in edit modal
        if (source.index === destination.index) return;

        // Set flag to prevent SignalR from causing UI flicker during the operation
        setDragOperationInProgress();
        
        try {
            // Use siblingOrder for edit modal (consistent with Overview page behavior)
            let children = todo.children.slice().sort((a, b) => a.siblingOrder - b.siblingOrder)
                .filter((child) => !showCompleted ? !child.isCompleted : true);

            // Get ordered IDs array after moving the task
            const orderedIds = children.map(child => child.id);
            const movedTask = children[source.index];
            const draggedId = movedTask.id;
            
            // Remove the dragged item from its current position
            const draggedIndex = orderedIds.indexOf(draggedId);
            if (draggedIndex > -1) {
                orderedIds.splice(draggedIndex, 1);
            }
            
            // Insert at the new position
            orderedIds.splice(destination.index, 0, draggedId);

            // Call the orderSiblings endpoint
            const json = {
                id: todo.id,  // Parent ID
                Ids: orderedIds
            };

            // Optimistic update - immediately update local state before API call
            dispatch(orderSiblingsSynchronously(todo.id, orderedIds));
            
            await dispatch(orderSiblingsInTodo(json));
        } finally {
            // Always clear the flag when operation completes (success or error)
            clearDragOperation();
        }
    }

};

